import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';
import _ from 'lodash';

interface BusinessTagModelState extends ModelState {
  tmpList: { name: string; color: string }[];
}

const getInitialState = (): BusinessTagModelState => ({
  single: null,
  list: [],
  tmpList: [],
});

const state: BusinessTagModelState = {
  ...getInitialState(),
};

const getters: GetterTree<BusinessTagModelState, RootState> = {
  mappedList: (state) => _.uniqBy([...state.list, ...state.tmpList], 'name'),
};

const actions: ActionTree<BusinessTagModelState, RootState> = {
  fetchList({ commit }, payload) {
    http.v1.bt.fetchList(payload).then(({ data }) => {
      const payload = data.data;
      commit('SET_STATE', { key: 'list', payload });
    });
  },
  create({ dispatch }, payload) {
    return http.v1.bt.create({ ...payload }).then(() => {
      dispatch('fetchList', {
        params: {
          business_oid: payload.business_oid,
        },
      });
    });
  },
  update({ dispatch }, { object_id, data }) {
    return http.v1.bt
      .update(object_id, {
        ...data,
      })
      .then(() => {
        dispatch('fetchList', {
          params: {
            business_oid: data.business_oid,
          },
        });
      });
  },
  delete({ dispatch }, { object_id, data }) {
    return http.v1.bt
      .delete(object_id, {
        data,
      })
      .then(() => {
        dispatch('fetchList', {
          params: {
            business_oid: data.business_oid,
          },
        });
      });
  },
};

const mutations: MutationTree<BusinessTagModelState> = {
  SET_STATE(state, { key, payload }) {
    state[key] = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getInitialState());
  },
};

const businessTag: Module<BusinessTagModelState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default businessTag;
